import { Form, Input } from 'antd'
import { useEffect, useRef } from 'react'
import { ButtonCommon } from 'src/common'
import { useAppDispatch } from 'src/hooks'
import {
	onCreateDictWordExample,
	onUpdateDictWordExample,
} from 'src/redux/definition/definition.actions'
import { showMessageError, showMessageSuccess } from 'src/utils/function.utils'

const TextArea = Input.TextArea

export const FormEditExample = ({
	id,
	initialValues,
	wordMeaningID,
	dictWordID,
}) => {
	const dispatch = useAppDispatch()
	const inputRef = useRef()
	const [form] = Form.useForm()

	useEffect(() => {
		inputRef.current.focus()
	}, [])

	useEffect(() => {
		form.setFieldValue(initialValues)
	}, [initialValues, form])

	const handleSubmit = async () => {
		const values = await form.validateFields()

		if (id) {
			// mode edit
			dispatch(
				onUpdateDictWordExample(
					{
						...values, // example, translate
						id,
						wordMeaningID,
						dictWordID,
					},
					handleSubmitCb
				)
			)
		} else {
			// mode add
			dispatch(
				onCreateDictWordExample(
					{
						...values, // example, translate
						wordMeaningID,
						wordID: dictWordID,
					},
					handleSubmitCb
				)
			)
		}
	}

	const handleSubmitCb = (isSuccess, rs) => {
		if (isSuccess) {
			showMessageSuccess()
		} else {
			showMessageError(rs)
		}
	}

	return (
		<Form form={form} initialValues={initialValues}>
			<Form.Item
				label="Example"
				name="example"
				rules={[
					{
						required: true,
						message: 'Please enter example',
					},
				]}
			>
				<TextArea ref={inputRef} placeholder={`Enter example`} />
			</Form.Item>

			<Form.Item label="Translation" name="translate">
				<TextArea placeholder={`Enter translation`} />
			</Form.Item>

			<div className="u-row-right">
				<ButtonCommon onClick={handleSubmit} type="primary">
					Save
				</ButtonCommon>
			</div>
		</Form>
	)
}
